export enum IdCardSides {
    Front = "front",
    Back = "back"
}
